'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/okveds/:okvedId', null, {
            getAll: {method: 'GET'},
            get: {method: 'GET'},
            create: {method: 'POST'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            enable: {url: 'api/okveds/:okvedId/enable', method: 'PUT'},
            delete: {url: 'api/okveds/:okvedId/delete', method: 'PUT'},
            getDefault: {url: 'api/okveds/default', method: 'GET'},
            setDefault: {url: 'api/okveds/:okvedId/default', method: 'PUT'},
            isUniqueName: {url: 'api/okveds/unique/name/:name', method: 'GET'},
            tree: {url: 'api/okveds/tree', method: 'GET'},
            unique: {url: 'api/okveds/unique', method: 'GET'},
            root: {url: 'api/okveds/root', method: 'GET'},
            childs: {url: 'api/okveds/:okvedId/childs', method: 'GET'},
            path: {url: 'api/okveds/:okvedId/path', method: 'GET'},
        });
    }];